import { useEffect, useState } from "react";
import { loadTrends, loadRVRTrends } from "../http/fetch-status";
import Boxplot, { computeBoxplotStats } from "react-boxplot";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar, Scatter } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CampaingTrends = ({}) => {
  let dataSets = {
    labels: [],
    datasets: [
      {
        label: "Destro Total Kills",
        data: [1, 2, 3],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Order Total Kills",
        data: [],
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  let dataSets2 = {
    labels: [],
    datasets: [
      {
        label: "Destro % of Kills",
        data: [1, 2, 3],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Order % of Kills",
        data: [],
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  let dataSets3 = {
    labels: [],
    datasets: [
      {
        label: "Order Percentage of All Kills",
        data: [1, 2, 3],
        borderColor: "rgba(200, 200, 200, 0.8)",
        backgroundColor: "rgba(200, 200, 200, 0.8)",
      },
      {
        label: "50%",
        data: [1, 2, 3],
        borderColor: "rgba(255, 153, 0, 0.9)",
        backgroundColor: "rgba(255, 153, 0, 0.9)",
        pointRadius: 0,
        lineWeight: 1,
      },
      {
        label: "60%",
        data: [1, 2, 3],
        borderColor: "rgba(255, 153, 0, 0.4)",
        backgroundColor: "rgba(255, 153, 0, 0.4)",
        pointRadius: 0,
        lineWeight: 0.5,
      },
      {
        label: "40%",
        data: [1, 2, 3],
        borderColor: "rgba(255, 153, 0, 0.4)",
        backgroundColor: "rgba(255, 153, 0, 0.4)",
        pointRadius: 0,
        lineWeight: 0.5,
      },
    ],
  };

  let dataSets4 = {
    labels: [],
    datasets: [
      {
        label: "Most Active Zone % of Kills",
        data: [1, 2, 3],
        borderColor: "rgb(200, 200, 200)",
        backgroundColor: "rgb(200, 200, 200)",
      },
    ],
  };

  let popDataSets = {
    labels: [],
    datasets: [
      {
        label: "Order Percentage of Population",
        data: [1, 2, 3],
        borderColor: "rgb(200, 200, 200)",
        backgroundColor: "rgba(200, 200, 200, 0.5)",
      },
      {
        label: "50%",
        data: [1, 2, 3],
        borderColor: "rgba(255, 153, 0, 0.5)",
        backgroundColor: "rgba(255, 153, 0, 0.5)",
        pointRadius: 0,
        lineWeight: 1,
      },
    ],
  };

  let totalPopDataSets = {
    labels: [],
    datasets: [
      {
        label: "Population",
        data: [1, 2, 3],
        borderColor: "rgb(200, 200, 200)",
        backgroundColor: "rgba(200, 200, 200, 0.5)",
      },
    ],
  };

  const [hourFrom, setHourFrom] = useState(19);
  const [hourTo, setHourTo] = useState(22);
  const [days, setDays] = useState(7);
  const [weekday, setWeekday] = useState("All");

  const [data, setData] = useState(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);
  const [histogramData, setHistogramData] = useState(null);
  const [popData, setPopData] = useState(null);
  const [totalPopData, setTotalPopData] = useState(null);
  const [popHistogramData, setPopHistogramData] = useState(null);

  const [boxPlotData, setBoxPlotData] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ]);

  const [totalOrderKills, setTotalOrderKills] = useState(0);
  const [totalDestroKills, setTotalDestroKills] = useState(0);
  const [avgOrderPop, setAvgOrderPop] = useState(0);
  const [medianOrderKills, setMedianOrderKills] = useState(0);

  const [killPopScatterData, setKillPopScatterData] = useState();

  const [loading, setLoading] = useState(true);

  const [loadingRvR, setLoadingRvR] = useState(true);
  const [rvrTrends, setRvrTrends] = useState(null);
  const [timezone, setTimezone] = useState(3);
  const [realm, setRealm] = useState("Any");

  const [zoneTrends, setZoneTrends] = useState(null);
  const [zoneTrendHistogram, setZoneTrendHistogram] = useState(null);

  const fetchRvRData = async () => {
    //setLoadingRvR(true);
    const response = await loadRVRTrends({ timezone: timezone, realm: realm });
    console.log(response.data);

    const dataset = {
      labels: response.data.map((item) => item.week),
      datasets: [
        {
          label: "Assists per Kill",
          data: response.data.map((item) => item["assists:kill"]),
          borderColor: "rgba(255, 153, 0, 0.5)",
          backgroundColor: "rgba(255, 153, 0, 0.5)",
        },
      ],
    };
    setRvrTrends(dataset);

    setLoadingRvR(false);
  };

  const fetchData = async () => {
    const qty = (hourTo - hourFrom) * 2 * days;
    const response = await loadTrends({ hourTo, hourFrom, qty, weekday });
    console.log(response.data);
    //setData(response.data);

    // revese the data
    const rawData = response.data.reverse();

    const _totalOrderKills = rawData.reduce((a, b) => a + b.order_kills, 0);
    setTotalOrderKills(_totalOrderKills);
    const _totalDestroKills = rawData.reduce((a, b) => a + b.destro_kills, 0);
    setTotalDestroKills(_totalDestroKills);

    // map order_kills to dataset
    dataSets.datasets[1].data = rawData.map((item) => item.order_kills);
    // map destro_kills to dataset
    dataSets.datasets[0].data = rawData.map((item) => item.destro_kills);

    // map order_kills to dataset
    dataSets2.datasets[1].data = rawData.map((item) => item.order_kill_percent);

    dataSets4.datasets[0].data = rawData.map((item) => item.zone_data);

    // clone data and sort it
    const sorted_order_kills = [...rawData].sort(
      (a, b) => a.order_kill_percent - b.order_kill_percent
    );

    // get median order kill percent
    const _medianOrderKills =
      sorted_order_kills[Math.floor(rawData.length / 2)];

    setMedianOrderKills(_medianOrderKills.order_kill_percent);

    // map destro_kills to dataset
    dataSets2.datasets[0].data = rawData.map(
      (item) => 100 - item.order_kill_percent
    );

    dataSets3.datasets[0].data = rawData.map((item) => item.order_kill_percent);
    dataSets3.datasets[1].data = rawData.map((item) => 50);
    dataSets3.datasets[2].data = rawData.map((item) => 40);
    dataSets3.datasets[3].data = rawData.map((item) => 60);

    popDataSets.datasets[0].data = rawData.map(
      (item) => item.population["order%"]
    );
    popDataSets.datasets[1].data = rawData.map((item) => 50);
    popDataSets.labels = rawData.map((item) => parseDate(item.created_at));

    totalPopDataSets.datasets[0].data = rawData.map(
      (item) => item.population.population
    );
    totalPopDataSets.labels = rawData.map((item) => parseDate(item.created_at));

    console.log(totalPopDataSets);

    const _avgOrderPop = rawData.reduce(
      (a, b) => a + b.population["order%"],
      50
    );
    setAvgOrderPop(_avgOrderPop / rawData.length);
    //map labels to created_at
    dataSets.labels = rawData.map((item) => parseDate(item.created_at));
    dataSets2.labels = rawData.map((item) => parseDate(item.created_at));
    dataSets3.labels = rawData.map((item) => parseDate(item.created_at));
    dataSets4.labels = rawData.map((item) => parseDate(item.created_at));

    // create histogram data from dataset3 with 50% line
    const bins = [
      4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76,
      80, 84, 88, 92, 96, 100,
    ];
    const histogramData = bins.map((bin) => {
      const count = dataSets3.datasets[0].data.filter((item) => {
        return item >= bin && item < bin + 4;
      }).length;
      return count;
    });

    const popHistogramData = bins.map((bin) => {
      const count = popDataSets.datasets[0].data.filter((item) => {
        return item >= bin && item < bin + 4;
      }).length;
      return count;
    });

    // create array of colors for histogram
    // 12 red, 1 rgb(200,200,200) then 12 blue
    const histogramGradient = histogramData.map((item, index) => {
      if (index < 9) {
        return "rgba(255, 99, 132, 0.5)";
      } else if (index < 11) {
        return "rgba(255, 99, 132, 0.5)";
      } else if (index === 11) {
        return "rgba(200, 200, 200, 0.5)";
      } else if (index < 14) {
        return "rgba(53, 162, 235, 0.5)";
      } else {
        return "rgba(53, 162, 235, 0.5)";
      }
    });

    const histogramDataset = {
      labels: bins.map((bin) => `${bin}-${bin + 4}`),
      datasets: [
        {
          label: "Percentage of Kills",
          data: histogramData,
          borderColor: "rgb(200, 200, 200)",
          backgroundColor: histogramGradient,
        },
      ],
    };
    setHistogramData(histogramDataset);

    const popHistogramDataset = {
      labels: bins.map((bin) => `${bin}-${bin + 4}`),
      datasets: [
        {
          label: "Percentage of Population",
          data: popHistogramData,
          borderColor: "rgb(200, 200, 200)",
          backgroundColor: histogramGradient,
        },
      ],
    };
    setPopHistogramData(popHistogramDataset);

    const _boxPlotData = rawData.map((item) => item.order_kill_percent);
    setBoxPlotData(_boxPlotData);

    const _zoneDataHistogramData = bins.map((bin) => {
      const count = dataSets4.datasets[0].data.filter((item) => {
        return item >= bin && item < bin + 4;
      }).length;
      return count;
    });

    setZoneTrendHistogram({
      labels: bins.map((bin) => `${bin}-${bin + 4}`),
      datasets: [
        {
          label: "Percentage of Kills",
          data: _zoneDataHistogramData,
          borderColor: "rgb(200, 200, 200)",
          backgroundColor: "rgba(200, 200, 200, 0.5)",
        },
      ],
    });

    setData(dataSets);
    setData2(dataSets2);
    setData3(dataSets3);
    setZoneTrends(dataSets4);
    //console.log(popDataSets);
    setPopData(popDataSets);
    setTotalPopData(totalPopDataSets);

    setKillPopScatterData({
      datasets: [
        {
          label: "kill% vs Population%",
          data: rawData.map((item) => {
            return {
              x: item.order_kill_percent,
              y: item.population["order%"],
            };
          }),
          backgroundColor: "rgba(255, 153, 0, 0.5)",
        },
      ],
    });

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [hourFrom, hourTo, days, weekday]);

  useEffect(() => {
    fetchRvRData();
  }, [timezone, realm]);

  // get height of parent div
  const parentDivHeight = () => {
    const parentDiv = document.querySelector("#match-height");
    return parentDiv.clientHeight;
  };

  // convert 2024-02-08T22:30:00.777266Z to 08-Feb-2024 22:30
  const parseDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}-${
      d.getMonth() + 1
    }-${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}`;
  };

  const options = {
    plugins: {
      title: {
        display: false,
        text: "Chart.js Bar Chart - Stacked",
      },
    },
    responsive: true,
    scales: {
      x: {},
      y: {
        min: 0,
      },
    },
  };

  const options2 = {
    plugins: {
      title: {
        display: false,
        text: "Chart.js Bar Chart - Stacked",
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        min: 0,
        max: 100,
      },
    },
  };

  const options3 = {
    height: 400,
    plugins: {
      title: {
        display: false,
        text: "Chart.js Bar Chart - Stacked",
      },
    },
    responsive: true,
    scales: {
      x: {},
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 50,
          color: "rgba(255, 255, 255, 1)",
        },
        gridLines: {
          display: true,
          color: "#FFFFFF",
        },
      },
    },
  };

  const options4 = {
    responsive: true,
    plugins: {
      title: {
        display: false,
        text: "Chart.js Bar Chart - Stacked",
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: false,
        title: {
          display: true,
          text: "<-- Destro | Order -->",
        },
      },
      y: {
        stacked: false,
        min: 0,
      },
    },
  };

  const options5 = {
    height: 400,
    plugins: {
      title: {
        display: false,
      },
    },
    responsive: true,
    scales: {
      x: {},
      y: {
        min: 0,
        ticks: {
          stepSize: 100,
          color: "rgba(255, 255, 255, 1)",
        },
        grid: {
          display: true,
          color: "rgba(255, 255, 255, 0.8)",
        },
      },
    },
  };

  const daysOfWeek = [
    "All",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return (
    <div className="container mx-auto">
      <div className="mt-1- grid grid-cols-4 gap-2">
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">HOUR FROM (UTC)</label>
          <select
            onChange={(e) => setHourFrom(e.target.value)}
            value={hourFrom}
          >
            {[...Array(24).keys()].map((i) => {
              return <option value={i}>{i}</option>;
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">HOUR TO (UTC)</label>
          <select onChange={(e) => setHourTo(e.target.value)} value={hourTo}>
            {[...Array(24).keys()].map((i) => {
              return <option value={i}>{i}</option>;
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">DAYS</label>
          <select onChange={(e) => setDays(e.target.value)} value={days}>
            {[...Array(365).keys()].map((i) => {
              return <option value={i + 1}>{i + 1}</option>;
            })}
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-xs text-gray-500">WEEK DAY</label>
          <select onChange={(e) => setWeekday(e.target.value)} value={weekday}>
            {daysOfWeek.map((i) => {
              return <option value={i}>{i}</option>;
            })}
          </select>
        </div>
      </div>
      <div className="my-20">
        <div className="mb-4 text-xl font-bold">
          {"RvR Kills "} {hourFrom}
          {"h to "}
          {hourTo}
          {"h over the last "}
          {days} {weekday == "All" ? " days" : " " + weekday + "s"}
        </div>
        <div className="mb-4 text-xl font-bold">
          {"Total Kills: "}
          <span className="text-sky-400">
            {"Order: "}
            {totalOrderKills}
          </span>
          <span className="text-red-400">
            {"  Destruction: "}
            {totalDestroKills}
          </span>
        </div>
        <div className="mb-4 text-xl font-bold">
          {"Average Kill Percent (mean): "}
          <span className="text-sky-400">
            {"Order: "}
            {(
              boxPlotData.reduce((a, b) => a + b, 0) / boxPlotData.length
            ).toFixed(1)}
            {"%"}
          </span>
          <span className="text-red-400">
            {"  Destruction: "}
            {100 -
              (
                boxPlotData.reduce((a, b) => a + b, 0) / boxPlotData.length
              ).toFixed(1)}
            {"%"}
          </span>
        </div>
        <div className="mb-4 text-xl font-bold">
          {"Typical Kill Percent (median): "}
          <span className="text-sky-400">
            {"Order: "}
            {medianOrderKills.toFixed(0)}
            {"%"}
          </span>
          <span className="text-red-400">
            {"  Destruction: "}
            {(100 - medianOrderKills).toFixed(0)}
            {"%"}
          </span>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-10">
          <div className="col-span-2" id="match-height">
            {!loading && <Line options={options3} data={data3} />}
          </div>
          <div>
            {!loading && (
              <Bar options={options4} data={histogramData} height={300} />
            )}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-20">
          <div className="mb-4 text-xl font-bold col-span-3">
            {"RoR T2+ Population Balance (homepage)"} {hourFrom}
            {"h to "}
            {hourTo}
            {"h over the last "}
            {days} {weekday == "All" ? " days" : " " + weekday + "s"}
          </div>
          <div className="mb-4 text-xl font-bold col-span-3">
            <span className="text-blue-400">
              {"Order "} {avgOrderPop.toFixed(1)}%
            </span>
            <span className="text-red-400">
              {"  Destruction "} {100 - avgOrderPop.toFixed(1)}%
            </span>
          </div>

          <div className="col-span-2" id="match-height">
            {!loading && <Line options={options3} data={popData} />}
          </div>
          <div>
            {!loading && (
              <Bar options={options4} data={popHistogramData} height={300} />
            )}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-20">
          <div className="mb-4 text-xl font-bold col-span-3">
            {"RoR T2+ Population (homepage)"} {hourFrom}
            {"h to "}
            {hourTo}
            {"h over the last "}
            {days} {weekday == "All" ? " days" : " " + weekday + "s"}
          </div>
          <div className="col-span-2" id="match-height">
            {!loading && <Line options={options5} data={totalPopData} />}
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-20">
          <div>
            {!loading && (
              <Scatter
                height={250}
                data={killPopScatterData}
                options={{
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "Population %",
                      },
                      max: 100,
                    },
                    x: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "Kills %",
                      },
                      max: 100,
                    },
                  },
                }}
              />
            )}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2 mt-20">
          <div className="col-span-3 text-xl font-bold" id="match-height">
            Active Zone % of Kills
          </div>
          <div className="col-span-2" id="match-height">
            {!loading && (
              <Line
                options={{
                  title: {
                    display: true,
                    text: "Most Active Zone % of Kills",
                  },
                  responsive: true,
                  scales: {
                    x: {
                      title: {
                        display: true,
                        text: "Week",
                      },
                    },
                    y: {
                      title: {
                        display: true,
                        text: "Most Active Zone % of Kills",
                      },
                      min: 0,
                      max: 100,
                    },
                  },
                }}
                data={zoneTrends}
              />
            )}
          </div>
          <div>
            {!loading && (
              <Bar
                options={{
                  responsive: true,
                }}
                data={zoneTrendHistogram}
                height={300}
              />
            )}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2 mt-20">
          <div className="col-span-3 text-xl font-bold" id="match-height">
            Number of Assists per Kill
          </div>
          <select
            value={timezone}
            onChange={(e) => setTimezone(e.target.value)}
          >
            <option value="0">Late EU/NA</option>
            <option value="1">NA</option>
            <option value="2">Early EU</option>
            <option value="3">EU Prime</option>
          </select>
          <select value={realm} onChange={(e) => setRealm(e.target.value)}>
            <option value="Any">Both Realms</option>
            <option value="ORDER">Order</option>
            <option value="DESTRO">Destro</option>
          </select>
          <div className="col-span-3" id="match-height">
            {!loadingRvR && (
              <Line
                options={{
                  responsive: true,
                  scales: {
                    x: {
                      title: {
                        display: true,
                        text: "Week",
                      },
                    },
                    y: {
                      title: {
                        display: true,
                        text: "Assists per Kill",
                      },
                      min: 2,
                      max: 10,
                    },
                  },
                }}
                data={rvrTrends}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaingTrends;
